import { extendTheme } from '@chakra-ui/react'
import { breakpoints } from 'theme/breakpoints'
import { colors } from 'theme/colors'
import { Alert } from 'theme/components/Alert'
import { Banner } from 'theme/components/Banner'
//components
import { Button } from 'theme/components/Button'
import { CardWrapperTheme } from '@kikin/ui-card/theme'
import { Checkbox } from 'theme/components/Checkbox'
import { Divider } from 'theme/components/Divider'
import { Drawer } from 'theme/components/Drawer'
import { Form } from 'theme/components/Form'
import { FormLabel } from 'theme/components/FormLabel'
import { Heading } from 'theme/components/Heading'
import { Input } from 'theme/components/Input'
import { Link } from 'theme/components/Link'
import { Menu } from 'theme/components/Menu'
import { Modal } from 'theme/components/Modal'
import { Progress } from 'theme/components/Progress'
import { SelectTheme } from '@kikin/ui-select/theme'
import { Skeleton } from 'theme/components/Skeleton'
import { Table } from 'theme/components/Table'
import { Tabs } from 'theme/components/Tabs'
import { Text } from 'theme/components/Text'
import { Textarea } from 'theme/components/Textarea'
import { Tooltip } from 'theme/components/Tooltip'
import { Radio } from 'theme/components/Radio'
//fonts
import { fonts } from 'theme/fonts'
//resized token scales
import { fontSizes, radii, sizes, space } from 'theme/scales'
//global styles
import { healthWalkthroughStyles } from 'components/HealthWalkthrough/styles'

export const customTheme = extendTheme({
    colors,
    styles: {
        global: (props: any) => ({
            body: {
                color: colors.green.default,
                bgColor: 'beige.background',
                // Without this, text carrying no explicit size or variant inherits the browser's
                // 16px default, which the resize never touched — so anything unstyled reads a
                // third larger than everything around it. Anchor it to the resized base scale.
                fontSize: 'md',
            },
            // Usually, input styles should handle this, but placeholder for react select is basically just treated as plain content wrapped in a div, alternatives are welcome
            '#react-select-2-placeholder': {
                color: `${colors.captions.placeholder} !important`,
            },

            // Chakra popovers have a min-width of max content which breaks the layout on smaller screens, this hack fixes it
            '.chakra-popover__popper': {
                minWidth: '0 !important',
            },
            // react big calendar popover
            'body .rbc-overlay': {
                zIndex: 'popover',
                '.rbc-overlay-header': {
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    mx: '4px',
                    border: 'none',
                },
                py: '11px',
                px: '4px',
                rounded: '8px',
                minWidth: '143px !important',
            },
            ...healthWalkthroughStyles,
        }),
    },
    fonts,
    components: {
        Button,
        Link,
        CardWrapper: CardWrapperTheme,
        Text,
        Heading,
        Input,
        Textarea,
        Form,
        FormLabel,
        Drawer,
        Alert,
        Progress,
        Tooltip,
        Checkbox,
        Skeleton,
        Tabs,
        Table,
        Menu,
        Modal,
        Divider,
        // Note: Using key 'Select' directly prevents variants from working properly
        CustomSelect: SelectTheme,
        Banner,
        Radio,
    },
    // Bordered card surfaces, so the chrome lives in one place instead of on each card.
    layerStyles: {
        card: {
            bgColor: 'white',
            borderWidth: '1px',
            borderColor: 'stroke.light',
            borderRadius: '8px',
        },
        dashboardCard: {
            bgColor: 'beige.highlighted',
            borderWidth: '1px',
            borderColor: 'stroke.light',
            borderRadius: '8px',
        },
    },
    breakpoints,
    fontSizes,
    space,
    radii,
    sizes,
})
